import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import { IExcedente } from '@model/Excedente';
import { useExcedenteService } from '@services/ExcedenteService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type ExcedenteCancelarModalProps = {
    modal: IModalWindow
    excedente: IExcedente
    onExcedenteCancelado: (response: AxiosResponse<IExcedente>) => void
}

export function ExcedenteCancelarModal ({ modal, excedente, onExcedenteCancelado }: ExcedenteCancelarModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const excedenteService = useExcedenteService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>)  => {
        if (!loading.isLoading) {
            loading.start();
            excedenteService.cancelar(excedente.excedenteId, values)
                .then(response => {
                    message.success("Excedente cancelado com sucesso");
                    modal.close();
                    onExcedenteCancelado(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [excedente.excedenteId, excedenteService, loading, message, modal, onExcedenteCancelado]);

    return (
        <JustificativaModal 
            confirmText="Cancelar Excedente"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Cancelamento do Excedente ${excedente.excedenteId}`}
        />
    )
}